// @ngInject
function LoginDialogService($uibModal) {

    return {
        showDialog: showDialog
    };

    function showDialog(data) {
        data = data || {};
        data.authMessage = data.authMessage || null;
        data.isLoginState = data.isLoginState || false;

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            controller: 'LoginDialogController as vm',
            templateUrl: 'services/dialogs/loginDialog/loginDialog.tpl.html',
            size: 'sm'
        };

        modalDefaults.resolve = {
            authMessage: function() {
                return data.authMessage;
            }
        };

        if (data.isLoginState) {
            modalDefaults.backdrop = 'static';
            modalDefaults.keyboard = false;
        }

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function LoginDialogController($uibModalInstance,$location,authMessage,AuthApiService,UserTimeStampingDialogService, UserPasswordResetDialogService, AuthService, $translate) {
    var vm = this;

    //Parameters
    vm.user = {};
    vm.authError = null;
    vm.showTenantInputField = false;
    vm.tenantName = "";
    vm.reveal = false;

    //Methods
    vm.showDialogTimeStamping = showDialogTimeStamping;
    vm.authMessage = authMessage;
    vm.login = login;
    vm.showDialogResetPassword = showDialogResetPassword;
    vm.loginDisabled = loginDisabled;
    vm.inputDisabled = false;

    function loginDisabled(){
        return !vm.tenantName || vm.tenantName === "" || 
            !vm.user.password || !vm.user.password === "" ||
            !vm.user.username || !vm.user.username === "";
    }
    
    activate();

    function activate() {
        var absoluteUrl = $location.absUrl();
        var match = absoluteUrl.match(/(?:\/\?)([A-Za-z0-9]*)(?:\#?)/); //Find occurrences of "/?string"

        var tenantName;
        if (match !== null) {
            tenantName = match[1];
        }

        if (tenantName === undefined) {
            vm.showTenantInputField = true;
            console.log("Tenant is not included in URL.");
        } else {
            vm.showTenantInputField = false;
            vm.tenantName = tenantName;
            console.log("Tenant found. Tenant name is:");
            console.log(vm.tenantName);
        }
    }

    function login() {
        $uibModalInstance.startLoadingSpinner();
        vm.inputDisabled = true;
        AuthApiService.getToken(vm.user.username, vm.user.password, vm.tenantName).then(function(token) {
            $uibModalInstance.close({ Token: token, Tenant: vm.tenantName });
        }, function(error) {
            vm.inputDisabled = false;
            $uibModalInstance.stopLoadingSpinner();
            vm.authError = error.message;
        });
    }

    function showDialogTimeStamping() {
        $uibModalInstance.startLoadingSpinner();

        AuthApiService.getToken(vm.user.username, vm.user.password, vm.tenantName).then(function(token) {
            AuthService.setToken(token, vm.tenantName);
            UserTimeStampingDialogService.showDialogLoginless().then(function(response) {
                console.log("Returned from time stamping. Response:");
                console.log(response);
            }, function(error) {
                vm.authError = error.message;
            }).finally(function() {
                $uibModalInstance.stopLoadingSpinner();
            });

        }, function(error) {
            $uibModalInstance.stopLoadingSpinner();
            vm.authError = error.message;
        });

    }

    function showDialogResetPassword() {
        $uibModalInstance.startLoadingSpinner();

        //AuthApiService.getToken(vm.user.username, vm.user.password, vm.tenantName).then(function(token) {
            //AuthService.setToken(token);
            UserPasswordResetDialogService.showDialog().then(function(response) {
                console.log("Returned from time stamping. Response:");
                console.log(response);
            }, function(error) {
                vm.authError = error.message;
            }).finally(function() {
                $uibModalInstance.stopLoadingSpinner();
            });
        //}, function(error) {
            //$uibModalInstance.stopLoadingSpinner();
            //vm.authError = error.message;
        //});
    }
}

angular
    .module('services.dialogs.loginDialog', ['services.dialogs.resetLoginDialog'])
    .service('LoginDialogService', LoginDialogService)
    .controller('LoginDialogController', LoginDialogController);
